import { render, staticRenderFns } from "./elementText.vue?vue&type=template&id=571e63ea&scoped=true&"
import script from "./elementText.vue?vue&type=script&lang=js&"
export * from "./elementText.vue?vue&type=script&lang=js&"
import style0 from "./elementText.vue?vue&type=style&index=0&id=571e63ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "571e63ea",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VTextarea})
